import { ReturnTrackingTriggerKey } from "@redotech/redo-model/advanced-flow/triggers";
import { SendEmailProps } from "@redotech/redo-model/email/send-email-props";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const sendEmailFromTemplate = {
  name: "sendEmailFromTemplate" as const,
  input: z.object({
    sendEmailProps: SendEmailProps,
    returnId: zExt.objectId().optional(),
    triggerKey: createEnum(Object.values(ReturnTrackingTriggerKey)).optional(),
  }),
  output: z.object({ success: z.boolean(), error: z.string().optional() }),
};
